import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { IoHandLeft } from 'react-icons/io5';

import { Button, Tooltip } from '@mantine/core';

import { CompanyProfile, PermissionCompany } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';

const RequestAccess = ({ company }: { company: CompanyProfile }) => {
    const search = useSearchParams();
    const canEdit = useProfilePermission(PermissionCompany.EDIT);
    const isPreviewUrl = search?.get('preview');

    if (canEdit || isPreviewUrl) return null;

    const copy = {
        label: company.internal ? 'Claim this profile' : 'Request Access',
        tooltip: company.internal
            ? 'Do you work for this company? Claim this profile to manage this profile.'
            : 'Do you work for this company? Request access to join this profile.',
    };

    return (
        <Tooltip label={copy.tooltip}>
            <Button
                component={Link}
                href={CompanyHelpers.urls.requestAccess(company.slug)}
                leftSection={<IoHandLeft />}
                variant="default"
                size="sm"
            >
                {copy.label}
            </Button>
        </Tooltip>
    );
};

export { RequestAccess };
